import './popups.component.scss'

import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

const popupsContainer = document.querySelector('.popups')

if (popupsContainer) {
  const popupsList = popupsContainer.querySelectorAll('.popup-layout')

  const isNoOpenedItems = () => {
    if (!document.querySelector('.popup-layout.opened')) {
      return true
    }
  }
  const hiding = (elem) => {
    elem.classList.add('hiding')
    setTimeout(() => {
      elem.classList.remove('hiding')
    }, 450)
  }

  const popups = {
    element: popupsContainer,
    statuses: {
      opened: false
    },
    open() {
      this.element.classList.add('opened')
      this.statuses.opened = true
    },
    close() {
      this.element.classList.remove('opened')
      hiding(this.element)
      this.statuses.opened = false
      clearAllBodyScrollLocks()
      document.documentElement.classList.remove('body-locked')
    },
    toggle() {
      if (!this.statuses.opened) {
        this.open()
      } else if (this.statuses.opened && isNoOpenedItems()) {
        this.close()
      }
    },
    forceClose() {
      this.element.querySelectorAll('.popup-ext.opened').forEach(popup => {
        popup.classList.remove('opened')
      })

      this.close()
    }
  }

  popupsList.forEach(item => {
    const itemObj = {
      element: item,
      statuses: {
        opened: false,
        active: false,
      },
      open(e) {
        e.preventDefault()

        const openCond = e.target.dataset.name !== 'face'

        if (openCond) {
          this.last = document.querySelector('.popup-ext.opened')
          if (this.last) {
            this.last.classList.remove('active')
            hiding(this.last)
          }

          this.statuses.opened = true
          this.element.classList.add('opened')
          this.element.classList.add('active')

          disableBodyScroll(this.element.querySelector('.popup-layout__content'))
          document.documentElement.classList.add('body-locked')

          popups.toggle()
        }
      },
      close(e) {
        if (e) {
          e.preventDefault()
        }

        if (this.statuses.isCloseAll) {
          this.statuses.opened = false
          this.element.classList.remove('opened')
          this.element.classList.remove('active')

          hiding(this.element)

          popups.forceClose()
        } else {
          this.statuses.opened = false
          this.element.classList.remove('opened')
          this.element.classList.remove('active')

          hiding(this.element)

          if (this.last) {
            this.last.classList.add('active')
            this.last = null
          }

          popups.toggle()
        }
      }
    }

    itemObj.statuses.isCloseAll = itemObj.element.hasAttribute('data-close-all')

    const dataPopup = item.getAttribute('data-popup')
    const openBtns = document.querySelectorAll(`[data-popup-link='${dataPopup}']`)
    const closeBtns = item.querySelectorAll('.popup-layout__overlay, .popup-layout__close')

    openBtns.forEach(item => {
      item.addEventListener('click', itemObj.open.bind(itemObj))
    })

    closeBtns.forEach(item => {
      item.addEventListener('click', itemObj.close.bind(itemObj))
    })

    // const inputSubmit = item.querySelector('[type="submit"]')
    // const popupForm = item.querySelector('form')
    // if (inputSubmit && popupForm) {
    //     inputSubmit.addEventListener('click', e => {
    //         const formSuccessObserver = new MutationObserver(mutationRecords => {
    //             if (mutationRecords[0].target.classList.contains('sent')) {
    //                 itemObj.close()
    //                 formSuccessObserver.disconnect()
    //             }
    //         })

    //         formSuccessObserver.observe(popupForm, {
    //             attributes: true
    //         })
    //     })
    // }
  })

  const popupDescriptions = popupsContainer.querySelectorAll('.popup-description')

  popupDescriptions.forEach(descEl => {
    const btnEl = descEl.querySelector('.popup-description__toggle-btn')
    const btnTextEl = descEl.querySelector('.link-arrow__text')

    const innerEl = descEl.querySelector('.popup-description__inner')
    const openText = descEl.dataset.btnOpen
    const closeText = descEl.dataset.btnClose

    if (btnEl) {
      btnEl.addEventListener('click', () => {
        if (innerEl.classList.contains('opened')) {
          btnTextEl.innerHTML = closeText
        } else {
          btnTextEl.innerHTML = openText
        }
      })
    }
  })
}